module.exports = __webpack_public_path__ + "assets/5a737f24cccde9bc172aea4409c95c5d.icon_verified.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/icon_verified.svg
 ** module id = 836
 ** module chunks = 1
 **/